import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import GeneralTooltip from '../general-tooltip';
import { useOnClickOutside } from '../../lib/hooks';

const Container = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 4px;
    height: 20px;
    background-color: ${(props) => (props.selected ? props.theme.colors['surface-grey-200'] : props.theme.colors['surface-grey-050'])};
    border-radius: 2px;
    font-size: 12px;
    letter-spacing: 0.32px;
    line-height: 16px;
    color: ${(props) => props.theme.colors['surface-grey-700']};
    user-select: none;
    cursor: pointer;
`;

const Bold = styled.span`
    font-weight: 600;
`;

const HightlightScore = styled(Bold)`
    color: ${(props) => props.theme.colors['surface-grey-800']};
`;

const TooltipContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 256px;

    & a {
        text-decoration: underline;
        color: white;
    }
`;

const ScoreCounter = ({ points, total }) => {
    const [selected, setSelected] = useState(false);
    const ref = useRef();

    useOnClickOutside(ref, () => {
        setSelected(false);
    });

    return (
        <Container
            onClick={(e) => {
                e.stopPropagation();
                setSelected((oldValue) => !oldValue);
            }}
            onMouseOver={() => setSelected(true)}
            onMouseLeave={() => setSelected(false)}
            selected={selected}
            ref={ref}
        >
            <HightlightScore>{points.toFixed(2)}</HightlightScore>
            <span>{`/${total}`}</span>
            {selected && (
                <GeneralTooltip position="bottom">
                    <TooltipContent>
                        <span>
                            {'Questo è il '}
                            <Bold>{'punteggio parziale '}</Bold>
                            {'totalizzato per questo esercizio.'}
                        </span>
                        <span>{'Vuoi capire meglio come funziona?'}</span>
                        <div>
                            <a href="/support" target="_blank">
                                {'Leggi le domande frequenti'}
                            </a>
                        </div>
                    </TooltipContent>
                </GeneralTooltip>
            )}
        </Container>
    );
};

ScoreCounter.propTypes = {
    points: PropTypes.number,
    total: PropTypes.number,
};

export default ScoreCounter;
